import { defineStore } from 'pinia'
import type { User } from 'firebase/auth'

export const useAuthStore = defineStore('authStore', () => {
    const user = ref<User | null>(null)
    const loading = ref(true)

    const userCookie = useCookie('user')
    const isLoggedIn = computed(() => !!user.value || !!userCookie.value)

    function setUser(newUser: User | null) {
        user.value = newUser
        loading.value = false
    }

    function clearUser() {
        user.value = null
        userCookie.value = null
        if (import.meta.client) {
            document.cookie = 'user=; Max-Age=0; path=/';
        }
        loading.value = false
    }

    return {
        user,
        loading,
        isLoggedIn,
        setUser,
        clearUser
    }
})
